import React from 'react';
import PropTypes from 'prop-types';

import Source from './components/Source';
import mediaQueries from './mediaQueries';
import applySkeleton from '../../hocs/applySkeleton';

const Image = ({ imageAsset, theme }) => {
    const { altText, urls = [] } = imageAsset;

    if (urls.length === 0) return null;

    const defaultImage = urls.find(({ device }) => device === 'desktop');
    const defaultUrl = defaultImage && defaultImage.url;

    return (
        <picture className={ theme.root }>
            {
                urls.map(({ url, device }) => (
                    <Source
                        images={ urls }
                        mediaQuery={ mediaQueries.find(mediaQuery => mediaQuery.device === device) }
                        key={ url }
                    />
                ))
            }
            <img src={ defaultUrl } alt={ altText } className={ theme.image } />
        </picture>
    );
};

Image.propTypes = {
    imageAsset: PropTypes.shape({
        urls: PropTypes.arrayOf(
            PropTypes.shape({
                device: PropTypes.string,
                height: PropTypes.number,
                url: PropTypes.string,
                width: PropTypes.number,
            })
        ),
        altText: PropTypes.string,
    }),
    theme: PropTypes.shape({}),
};

Image.defaultProps = {
    imageAsset: {
        urls: [],
        alt: '',
    },
    theme: {},
};

export default applySkeleton(Image, { type: 'picture' });
